import { observable } from "mobx";


export class SrovnavacState {

    dislayedDetailUserInfo = observable({
        value: false
    })
}
